import Grid from '@mui/material/Grid2';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import backgroundSection5 from "../../../../images/backgroundSection5.jpg";

function CollectivePlansSection() {
  return (
    <section
      className="bg-no-repeat bg-cover bg-center"
      style={{ backgroundImage: `linear-gradient(rgba(14,30,80,0.88),rgba(14,30,80,0.88)), url(${backgroundSection5})` }}
    >
      <div className="max-w-[1200px] mx-auto py-96 px-40">
        <Grid container spacing={6} alignItems="center">

          <Grid size={{ xs: 12, md: 5 }}>
            <div className="bg-white/[0.06] border border-white/15 rounded-20 h-full min-h-[340px] flex flex-col items-center justify-center py-48 px-32 text-center">
              <AccountBalanceIcon className="!text-60 text-[rgba(56,189,248,0.3)] mb-24" />
              <p className="text-18 text-white/70 leading-[1.6]">
                Una sola plataforma para centralizar, validar y reportar la gestión de múltiples actores.
              </p>
            </div>
          </Grid>

          <Grid size={{ xs: 12, md: 7 }}>
            <div className="inline-flex items-center gap-8 bg-[rgba(56,189,248,0.15)] text-[#38BDF8] font-bold text-14 tracking-[0.06em] uppercase py-6 px-16 rounded-full mb-24 border border-[rgba(56,189,248,0.3)]">
              <AccountBalanceIcon className="!text-18" />
              Planes colectivos
            </div>

            <h2 className="text-40 font-extrabold text-white leading-[1.2] mb-24">
              Control total de la operación REP
            </h2>

            <p className="text-20 text-white/80 leading-[1.75] max-w-[600px]">
              Centraliza la información de múltiples actores y valida cada registro de manera estructurada.
            </p>
          </Grid>

        </Grid>
      </div>
    </section>
  );
}

export default CollectivePlansSection;
